
import { name, label, placeholder } from 'app/utils/designer/form/settings/common/commonBase';
import { onLoad, onChange, isVisible, isDisabled } from 'app/utils/designer/form/settings/common/commonEvents';
import { help } from 'app/utils/designer/form/settings/common/commonHelpers';
import { required, readOnly, classRequired, staticAttribute, maxLength, minLength } from 'app/utils/designer/form/settings/common/commonValidation';
import { validateMinMax } from 'app/utils/designer/form/settings/metadata/inputSettings';
import { flexGrow } from 'app/utils/designer/form/settings/common/commonStyles';
const _getMinMaxConstraints = settingsValues => validateMinMax(minLength, maxLength, 'constraints.minLength', 'constraints.maxLength');

const panels = settingsValues => [
    {
        header: 'Base',
        children: [name, label, placeholder],
    },
    {
        header: 'General',
        children: [
            {
                type: 'typeahead',
                clearable: false,
                properties: {
                    label: 'Type of parsing',
                    name: 'properties.parseAs',
                    valueField: 'value',
                    value: 'text',
                    clearable: false,
                    options: [
                        { value: 'text', label: 'Text' },
                        { value: 'JSON', label: 'JSON' },
                        { value: 'HTML', label: 'HTML' },
                        { value: 'javascript', label: 'Javascript' },
                    ],
                },
            },
        ],
    },
    {
        header: 'Events',
        children: [onLoad, onChange, isVisible, settingsValues?.viewType !== 'class' && isDisabled].filter(Boolean),
    },
    {
        header: 'Validation',
        children: [
            settingsValues?.viewType !== 'class' ? required : classRequired,
            settingsValues?.viewType === 'class' && readOnly,
            settingsValues?.viewType === 'class' && staticAttribute(settingsValues),
            ..._getMinMaxConstraints(settingsValues),
        ].filter(Boolean),
    },
    {
        header: 'Styles',
        children: [flexGrow,
            {
                type: 'header',
                properties: { 
                    text: 'Appearance',
                    variant: 'subtitle2',
                    style: { marginLeft: '8px' }
                },
            },
            { type: 'radioGroup',
                properties: {
                    name: 'properties.appearance',
                    defaultValue: 'small',
                    style: { marginLeft: '8px' },
                    formFieldProps: {
                        className: 'typeRadio',
                    },
                    options: [
                        { value: 'small', label: 'Minimised with scroll bar' },
                        { value: 'full', label: 'Full size' },
                    ],
                },
            },
        ]  
    },
    {
        header: 'Helpers',
        children: [help],
    },
];

export default {
    defaults: { rows: 5, parseAs: 'text', withDefault: true },
    panels: settingValues => panels(settingValues),
};
